var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v(" base control, should not be instantiated "),
      _c("br"),
      _vm._v(" the actual component should have these in the tempalte eg "),
      _c("pre", [
        _vm._v('    :color="color"\n    :dark="dark"\n    .\n    .\n    .\n  '),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }